import { render, staticRenderFns } from "./OrganizacionComponent.vue?vue&type=template&id=e5517c0e&lang=pug"
import script from "./OrganizacionComponent.vue?vue&type=script&lang=js"
export * from "./OrganizacionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5517c0e')) {
      api.createRecord('e5517c0e', component.options)
    } else {
      api.reload('e5517c0e', component.options)
    }
    module.hot.accept("./OrganizacionComponent.vue?vue&type=template&id=e5517c0e&lang=pug", function () {
      api.rerender('e5517c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrganizacionComponent.vue"
export default component.exports